export const QUIZ_PROGRESS_FEATURE_KEY = 'quizProgress';
